const colors = {
    black: '#0F0F0F',
    lightgrey: '#FAFAFA',
    white: '#FFFFFF',
    lead: '#454545',
    brand: '#25B676',
    lightbrand: 'rgba(37, 182, 118, 0.4)',
    darkbrand: '#1E9560',
    orange: '#ffa500',
    blue: '#0066cc',
    btnBlack: '#232323',
    btnInactive: 'rgba(35, 35, 35, 0.4);',
    btnHover: '#0F0F0F',
    errorTxt: '#ff0000',
    errorBc: '#ff5050',
    greyVarF0: '#F0F0F0',
    greyVarF1: '#F1F1F1',
    greyVarF2: '#F2F2F2',
    greyVarF3: '#F3F3F3',
    greyVarF5: '#F5F5F5',
    greyVarE0: '#E0E0E0',
    greyVarE4: '#E4E4E4',
    greyVarD8: '#D8D8D8',
    greyVarA3: '#A3A3A3',
    greyVar45: '#454545',
};
const fonts = {
    TTNormsProRegular: 'TTNormsPro-Regular',
    TTNormsProMedium: 'TTNormsPro-Medium',
};
const gradients = {};
const transitions = {};
const shadows = {};
const customMediaQuery = (minWidth) => `@media (min-width: ${minWidth}px)`;
const media = {
    custom: customMediaQuery,
    wide: customMediaQuery(1600),
    desktop: customMediaQuery(1200),
    laptop: customMediaQuery(922),
    tablet: customMediaQuery(768),
    phone: customMediaQuery(576),
};
const customMediaSizeQuery = (size) => `${size}px`;
const mediaSizes = {
    custom: customMediaSizeQuery,
    wide: customMediaSizeQuery(1600),
    desktop: customMediaSizeQuery(1200),
    laptop: customMediaSizeQuery(922),
    tablet: customMediaSizeQuery(768),
    phone: customMediaSizeQuery(576),
};
export const saTheme = {
    colors,
    fonts,
    shadows,
    gradients,
    transitions,
    media,
    mediaSizes,
};
